import React, { Component } from 'react';
import Avatar from "react-avatar";
import moment from 'moment';
import _ from 'lodash';
import GroupAvatar from "../../components/wishlist/GroupAvatar";
import CamelVoted from "../../assets/images/icon-camel-filled.svg";
import './WishCard.scss';

class WishCard extends Component {
  gotoDetail = (id) => {
    this.props.onClick(id);
  }

  render() {
    return (
      <div className="wish-card-container">
        <div className="header">
          <div className="status">{this.props.wish.status || 'Wished'}</div>
          <input type="checkbox"></input>
        </div>
        <div className="wish-content">
          <div className="profile">
            <Avatar
              name={this.props.wish.requestedByName}
              size={40}
              round={true}
              color="#63b3ed"
              fgColor="white"
              className="mr-2"
              src={_.get(this.props, 'wish.requestedByAvatar.medium', null)}
            />
            <div className="username">
              {this.props.wish.requestedByName}
            </div>
          </div>
          <div className="wish-content">
            <p>Wishes for:</p>
            <p className="why-box">{this.props.wish.title}</p>
          </div>
        </div>
        <div className="funnel-stage">{this.props.wish.contentType}</div>
        <div className="wish-actions">
          <div className="state-detail d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <img 
                src={CamelVoted}
                className="mr-2"
                alt="camel"
                id={true ? 'btnWishlistCardUnupvote' : 'btnWishlistCardUpvote'}
              />
              <span>{this.props.wish.upvoteCount}</span>
            </div>
            <GroupAvatar
              users={this.props.wish.upvotedBy || []}
              maxCount={4}
            />
            <div className="created-date d-flex align-items-center">{moment(this.props.wish.createdAt).fromNow()}</div>
          </div>
          <div className="btn-manage" onClick={() => this.gotoDetail(this.props.wish.id)}>
            MANAGE
          </div>
        </div>
      </div>
    )
  }
}

export default WishCard;
